var r, u;
function _() {
  if (u) return r;
  u = 1;
  var t = Math.ceil, v = Math.max;
  function g(e, h, n, l) {
    for (var R = -1, a = v(t((h - e) / (n || 1)), 0), i = Array(a); a--; )
      i[l ? a : ++R] = e, e += n;
    return i;
  }
  return r = g, r;
}
export {
  _ as __require
};
